let bannerList = [
  "https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/banner/fy_banner_04.png",
  "https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/banner/fy_banner_05.png",
  "https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/banner/fy_banner_06.png",
]

export default bannerList



// WEBPACK FOOTER //
// ./src/assets/conf/banner.js